<template>
  <div>
    <div>
      <div>
        <div class="dovemed-card">
          <h3 :style="{
            display: 'flex',
            'font-size': '32px',
            'font-weight': '700',
            'color': '#0F1734'
          }">
            Advocates
          </h3>
          <div class="search-container w-100" :style="{ 'font-size': '14px' }">
            <form onSubmit="return false;" class="w-100 d-flex align-items-center searchContainer">
              <font-awesome-icon :icon="['fal', 'search']" :style="{ color: getPrimaryColor() }" @click="callDebounce"
                class="cp ml-3" />
              <input type="search" class="search-input-state w-100" placeholder="Enter Location" v-model="searchLocation"
                @input="callDebounce" @keyup.enter="callDebounce" />
              <a-icon v-if="searchLocation" class="close-icon" type="close" :size="'large'" @click="()=>handleClearFilter('search')" />
            </form>
            <button type="submit" class="search-btn display-flex-row-center" @click="handleFilterBtn">
              <span>
                <img src="../../assets/icons/bars-filter-light.png" class="filter-icon" />
              </span>
              <span class="text-mob">Apply Filters</span>
              <AdvocateFilter :getfilteredAdvocates="getfilteredAdvocates" :filtervalue2="filtervalue2"
                :filtervalue3="filtervalue3" ref="AdvocateFilterModal" />
            </button>
          </div>
          <div v-if="filtervalue2 || filtervalue3" class="applied-filter-cont">
            <div class="show-filter">
              <div class="appliedFilter">Applied Filter:</div>
              <div v-if="filtervalue2 !== undefined" class="filterTypeBox">
                <div class="filterTypeText">{{ filtervalue2 === 10 ? '0-10 years old' :
                  `${Number(filtervalue2) - 9}-${filtervalue2} years old` }}</div>
                <i class="fa fa-times" aria-hidden="true" style="cursor: pointer"
                  @click="() => handleClearFilter('age')"></i>
              </div>
              <div v-if="filtervalue3 !== undefined" class="filterTypeBox">
                <div class="filterTypeText">{{ filtervalue3 }}</div>
                <i class="fa fa-times" aria-hidden="true" style="cursor: pointer"
                  @click="() => handleClearFilter('gender')"></i>
              </div>
            </div>
            <div @click="() => handleClearFilter('all')" :style="{ color: getPrimaryColor() }" class="clearFilter">
              Clear filters
            </div>
          </div>
          <div class="filter-container">
            <InviteOthersModal />
          </div>
        </div>
        <p class="result" v-if="advocates.length > 0 && !isLoadingData">
          <span>{{ count }} {{ count > 1 ? "Results" : "Result" }}</span>
        </p>
        <div class="mb-3" v-if="advocates.length > 0 && !isLoadingData" v-for="people in advocates" :key="people.id">
          <AdvocateCard :people="people"/>
        </div>
        <div v-if="advocates.length > 0 && !isLoadingData" class="pagination-container">
          <a-pagination class="dovemed-custom-pagination" v-model="currentPage" :total="pagination ? pagination : 0"
            show-less-items :showSizeChanger=false :pageSize="10" @change="handleChangePage" />
        </div>
      </div>
    </div>
    <div v-if="isLoadingData" class="d-flex justify-content-center mt-3">
      <div>
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">
        Loading...
      </div>
    </div>
    <div class="text-center cp" v-if="!isLoadingData && advocates.length <= 0">
      No Results Found
    </div>
    <AdvocateFilter />
  </div>
</template>
  




<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import InviteOthersModal from "../../components/Modals/InviteOthersModal.vue";
import AdvocateFilter from "../Modals/AdvocateFilter.vue";
import AdvocateCard from "./AdvocateCard.vue";
const UserRepository = RepositoryFactory.get("user");
const AppRepository = RepositoryFactory.get("app");

export default {
  name: "meetAdvocates",
  data() {
    return {
      activeUser: 0,
      isLoadingData: true,
      searchKey: null,
      searchLocation: "",
      type: "",
      advocates: [],
      pagination: "",
      currentPage: 1,
      filtervalue2: undefined,
      filtervalue3: undefined,
      loadingbtn: false,
      loadingrole:false,
    };
  },

  components: {
    AdvocateFilter,
    InviteOthersModal,
    AdvocateCard
},

  mounted() {
    this.getAllAdvocates();
  },
  methods: {


    callDebounce: _.debounce(function () {
      this.getAllAdvocates();
    }, 500),

    viewProfile(user) {
      this.loadingbtn = user.id;
      this.loadingrole = user.role;
      if (user.id === this.authUser.user.id && user.role === this.authUser.user.role) {
        this.routeToAuthProfile(this.authUser.user.role);
        this.loadingbtn = false;
        this.loadingrole = false;
      } else {
        this.$store.commit("User/setViewUser", {data: {... this.viewUser, isDirectory: false}})
        this.loadingbtn = false;
        this.loadingrole = false;
        switch (user.role) {
          case "doctor":
            this.$router
              .push({
                name: "ViewDoctorUpdates",
                params: { id: user.id }
              })
              .catch(() => {});
            break;
          case "patient":
            this.$router
              .push({
                name: "ViewPatientUpdates",
                params: { id: user.id }
              })
              .catch(() => {});
            break;
          case "caregiver":
            this.$router
              .push({
                name: "ViewPatientUpdates",
                params: { id: user.id, role: 'caregiver' }
              })
              .catch(() => {});
            break;
          case "advocate":
            this.$router
              .push({
                name: "ViewAdvocateUpdates",
                params: { id: user.id }
              })
              .catch(() => {});
            break;
          default:
            break;
        }
      }
      
    },

    handleInviteModal() {
      this.$refs.InviteOthersModal.show();
    },

    handleClearFilter(type){
      switch(type){
        case 'search':
          this.searchLocation=''
          break
        case 'age':
          this.filtervalue2=undefined
          break
        case 'gender':
        this.filtervalue3=undefined
          break
        case 'all':
        this.filtervalue2=undefined
        this.filtervalue3=undefined
          break
      }
      this.getfilteredAdvocates(this.filtervalue2,this.filtervalue3)
    },



    handleFilterBtn() {
      console.log("called handleFilterBtn");
      this.$refs.AdvocateFilterModal.show();
    },

    handleChangePage(page) {
      console.log(page, "pageination");
      this.currentPage = page;
      document.body.scrollTop = 0;
      this.getAllAdvocates(page);
    },

    getAllAdvocates(page) {
      this.isLoadingData = true;
      console.log(page);
      console.log(this.searchLocation);
      if (page === undefined) {
        page = 1;
      }
      AppRepository.getAllAdvocates(this.authUser.user.role, page, 10, this.currentCircle.id, this.searchLocation)
        .then(res => {
          if (res.data.data.data) {
            this.isLoadingData = false;
            this.advocates = res.data.data.data;
            this.pagination = res.data.data.paginator.total_count;
            if (page <= 1) {
              this.count = res.data.data.paginator.total_count
            }
          } else {
            this.isLoadingData = false;
            this.advocates = [];
          }
        })
        .catch(err => {
          this.isLoadingData = false;
          this.count = 0;
          this.advocates = [];
          console.log("error");
        });
    },


    getfilteredAdvocates(filtervalue2, filtervalue3) {
      this.isLoadingData = true;
      this.advocates = [];
      console.log(filtervalue2, filtervalue3)
      this.filtervalue2 = filtervalue2;
      this.filtervalue3 = filtervalue3;
      AppRepository.getAllAdvocates(this.authUser.user.role, 1, 10, this.currentCircle.id, this.searchLocation, this.filtervalue2, this.filtervalue3, 1)
        .then(res => {
          this.isLoadingData = false;
          if(res.data.data.hasOwnProperty('data')){
            this.advocates = res.data.data.data;
            this.count = res.data.data.paginator.total_count;
            console.log(this.advocates, "inside getfilteredAdvocates");
            this.pagination = res.data.data.paginator.total_count;
          }else{
            this.advocates = [];
            this.pagination = 0;
          }
        })
        .catch(err => this.isLoadingData = false);
    }
  }

};
</script>



<style lang="scss">
.state-mob {
  @media screen and (max-width:700px) {
    margin-left: 24px;
  }
}

.mob-resp {
  display: flex;
  flex-direction: row;
  width: 100%;

  @media screen and (max-width:700px) {
    flex-direction: column;
  }
}


.cont {
  @media screen and (max-width:700px) {
    padding-right: 0px;
    padding-left: 0px;
  }
}

.internal-loc {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.loc-text-cont {
  display: flex;
  flex-direction: row;
  gap: 4px;
}



.close-icon {
  margin-right: 20px;
  cursor: pointer;
  width: auto !important;
  margin-left: 0px !important;
}

.dovemed-custom-pagination .ant-pagination-item-active {
  background: #2A71D4;
  border: none;
}

.dovemed-custom-pagination .ant-pagination-item-active a {
  color: #FFFFFF !important;
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
}

.dovemed-custom-pagination .ant-pagination-item-active a:hover {
  color: #FFFFFF !important;
}
</style>
  
<style lang="scss" scoped >

.clearFilter{
  display: flex;
  justify-content: center;
  width: 100%;
  cursor: pointer;
}

.show-filter{
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}
.applied-filter-cont {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 16px;
  justify-content: space-between;
  @media screen and (max-width: 700px) {
    gap: 16px;
  }
}

.filterTypeBox {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  gap: 8px;
  background: #f1f5f9;
  border-radius: 6px;

  .filterTypeText {
    font-weight: 700;
    font-size: 14px;
    color: #0f1734;
    text-transform: capitalize;
  }
}

.appliedFilter {
  font-weight: 700;
  font-size: 14px;
  color: #647490;
  line-height: 24px;

  @media screen and (max-width: 700px) {
    display: none;
  }
}

@media screen and (max-width: 769px) {
  .right-items {
    p {
      margin-bottom: 1rem !important;
      margin-top: 0px !important;
    }
  }
}

.profileBtn {
  color: #fff;
}


.location-text {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #94A3B8;
}

.result {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #0F1734;
}

.pagination-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  width: 792px;
  height: 36px;

  @media screen and (max-width:700px) {
    width: 100%;
  }
}

.a-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;
  width: 790px;
}

.search-container {
  display: flex;
  gap: 24px;
}

.btn-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding: 0px;

  width: 126px;
  height: 111px;
}

.btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 126px;
  height: 48px;
  background: #2A71D4;
  border-radius: 6px;
  color: #FFFFFF;
  border: none;
  cursor: pointer;
}


.members {
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #0F1734;
}

.tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 8px;
  // height: 22px;
  // background: #E1EAF7;
  border-radius: 4px;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  // color: #2A71D4;
  justify-content: center;
  width: fit-content;
}

.name {
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #0F1734;
  cursor: pointer;
}

.loc {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 451px;
  height: 24px;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #94A3B8;
}

.info-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  width: 451px;
  height: 121px;
}

.image {
  width: 70px;
  height: 70px;
  border-radius: 5rem;
}

.line {
  width: 0px;
  background-color: #0F1734;
  height: 100%;

}

.profile-image {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 93px;
  height: 70px;
  cursor: pointer;
}

.cards {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 24px;
  gap: 24px;
  width: 790px;
  height: 159px;
  background: #FFFFFF;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}



.filter-icon {
  width: 24px;
  height: 24px;
}

.filter {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 12px 24px;
  width: 636px;
  height: 38px;
  border-radius: 6px;
  flex: none;
  order: 1;
  flex-grow: 1;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  text-decoration-line: underline;
  color: #0F1734;
  cursor: pointer;
}


.third-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 24px;

  width: 742px;
  height: 38px;

  flex: none;
  order: 2;
  align-self: stretch;
  flex-grow: 0;
}

.display-flex-row-center {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.invite-others {
  padding: 8px 0px;
  gap: 4px;
  width: 82px;
  height: 30px;
  border-radius: 6px;
  flex: none;
  order: 0;
  flex-grow: 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  text-transform: capitalize;
  color: #2A71D4;
}


.search-btn {
  padding: 8px;
  gap: 16px;
  width: 60px;
  height: 60px;
  background: #F1F5F9;
  border-radius: 8px;
  flex: none;
  order: 1;
  flex-grow: 0;
  color: #0F1734;
  border: none;
  cursor: pointer;

  @media screen and (max-width:600px) {
    width: 100%;
  }
}

input[type="search"]::placeholder {
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #94A3B8;
}

input:focus {
  border: none;
  outline: none;
}

form.nosubmit {
  border: none;
  padding: 0;
}

input:active {
  border: none;
  outline: none;
}

input.nosubmit {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 4px 4px 48px;
  gap: 8px;
  width: 658px;
  height: 60px;
  background: #F1F5F9;
  border-radius: 8px;
  background-image: url("../../assets/images/search-icon.png");
  background-repeat: no-repeat;
  background-position: 18px;
  font-weight: 700;
  font-size: 16px;
  line-height: 32px;
  border: none;
}


////
.meet-all {
  width: 100%;
  max-width: 400px;
  margin: auto;
  display: flex;
  justify-content: center;

  button {
    width: 50% !important;
    margin: 0;
  }
}

.filter-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.searchContainer {
  background-color: #f1f5f9 !important;
  border-radius: 8px !important;
  border: none !important;

  input {
    border: none !important;
  }
}

.card-section {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 56px;
}

.search-field {
  background: #f1f5f9;
  border-radius: 8px;
  border: none;
  margin-right: 24px;
  height: 60px;
}

.search-button {
  width: 100%;
  background: #f1f5f9;
  border: none;
}

.sort-text {
  font-weight: 400;
  font-size: 14px;
  color: #0f1734;
  margin-bottom: 0px;
  cursor: context-menu;
}

.dovemed-card {
  .meet-all {
    .dovemed-button-left {
      font-weight: bold;
      border-top-left-radius: 15 !important;
      border-bottom-left-radius: 15 !important;
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }

    .dovemed-button-right {
      font-weight: bold;
      border-top-left-radius: 0 !important;
      border-bottom-left-radius: 0 !important;
      border-top-right-radius: 15 !important;
      border-bottom-right-radius: 15 !important;
    }
  }
}

.text-mob {
  display: none;

  @media screen and (max-width: 750px) {
    display: flex;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #0F1734;
  }
}

.search-container {
  display: flex;
  margin-top: 24px;
  gap: 24px;

  @media screen and (max-width: 750px) {
    flex-direction: column;
  }

  .search-input-state {
    background: none;
    border-left: 0 !important;
    height: 60px;
    outline: none;
    font-weight: 700;
    font-size: 16px;
    line-height: 32px;

    &:focus {
      outline: none;
    }
  }

  .search-button {
    max-width: 60px;
    min-width: 60px;
    border-radius: 8px;
    height: 60px;

    @media screen and (max-width: 750px) {
      max-width: 100%;
      width: 100%;
    }

    &:focus {
      outline: none;
    }
  }
}

.dovemed-button {
  padding: 12px 45px;
}

// STYLES MEETPEOPLE
.meet-others {
  display: flex;
  align-items: center;

  button {
    display: flex;
    margin-right: 24px;
    font-size: 14px;
    border-radius: 6px;
    padding: 12px 24px;
    width: 126px;
    height: 48px;
    font-family: 'Lato';
    font-style: normal;
    font-weight: 700;

    @media screen and (max-width:600px) {
      width: 100%;
      justify-content: center;
    }
  }

  span {
    font-size: 14px !important;
  }

}

.results {
  font-size: 20px;
  color: #0F1734;
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
}

.search-field {
  background: #f1f5f9;
  border-radius: 8px;
  border: none;
  margin-right: 24px;
}

.signup-page {
  padding: 70px;
}

.divider {
  height: 159px;
  border: 1px solid #cbd5e1;
  margin-top: -16px;
  background: #cbd5e1;
  margin-left: 35.5px;
  margin-bottom: -16px;
  @media screen and (max-width:750px) {
    height: 210px;
  }
}

.search-container {
  display: flex;

  @media screen and (max-width:750px) {
    flex-direction: column;
  }

  .search-input {
    padding: 10px;
    border-radius: 8px 0 0 8px;
    width: 95%;

    &:focus {
      outline: none;
    }
  }

  display: flex;
  align-items: center;

  .search-input-state {
    border-left: 0 !important;
    padding: 10px;
    width: 320px;

    &:focus {
      outline: none;
    }
  }

  .dropdownOptions {
    margin-right: 154px;
  }

  .search-button {
    max-width: 100px;
    padding: 11px;

    @media screen and (max-width: 900px) {
      padding: 6px;
    }

    @media screen and (max-width: 750px) {
      max-width: 100%;
      width: 100%;
    }

    &:focus {
      outline: none;
    }
  }
}

.input-placeholder {
  min-width: unset;

  &.male {
    border-radius: 20px 0 0 20px;
  }

  &.female {
    border-radius: 0 0 0 0;
    margin-left: -5px;
  }

  &.other {
    border-radius: 0 20px 20px 0;
    margin-left: -5px;
  }
}

.claim-card {
  border: 1px solid #E2E8F0;
  width: 100%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);

  .user-name {
    //height: 159px;

    @media screen and (max-width:600px) {
      // height: 243px !important;
    }

    .bg-img {
      position: relative;
      // border: 1px solid #ccc;
      // min-width: 100px;
      max-width: 100px;
      min-height: 100px;
      max-height: 100px;
      border-radius: 50%;
      display: inline-block;
      // margin-top: 24px;
      margin-left: 19.5px;

      @media screen and (max-width:600px) {
        margin-left: 0 !important;
        margin-top: 0px;
      }

      .rating-badge {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 20%);
        font-size: 15px;
        border-radius: 20px;
        width: 55%;
      }
    }
  }

  .user-address {
    line-height: 15px;
  }

  .dovemed-card-footer {
    border-top: 1px solid rgba(0, 0, 0, 0.125);

    span {
      font-size: 12px;
    }
  }
}

.claim-modal-header {
  border-radius: 5px 5px 0 0;
  min-height: 100px;
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;

  .profile-img {
    min-width: 150px;
    max-width: 150px;
    min-height: 150px;
    max-height: 150px;
    display: block;
    border-radius: 50%;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
    box-shadow: 0px 5px 7px 0px rgba(0, 0, 0, 0.4);
  }
}

.profile-details {
  padding-top: 170px;
  max-width: 60%;
  margin: auto;
}

.terms-modal-container {
  padding: 30px;
  text-align: center;
}

.background-image {
  background-position: center !important;
  background-size: contain !important;
  background-repeat: no-repeat !important;
}

.filters-cont {
  transition: height 0.3s ease-in-out;
}

.transparent {
  opacity: 0;
  display: none;
}

.no-results-container {
  background: rgb(246, 246, 246);
  padding: 20px;
  border-radius: 8px;
}

@media screen and (max-width: 581px) {
  .search-input-state {
    width: 100%;
  }

  .filters-cont {
    .filter-content {
      display: flex;
      flex-direction: column;
    }

    .input-placeholder {
      padding: 8px 8px;
    }
  }
}

.clear-filter {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  text-decoration-line: underline;
  margin-top: 28px;
  margin-right: 28px;

}

.right-items {
  display: flex;
  width: 100%;
  justify-content: space-between;
  overflow: none !important;
  margin-left: 24px;
  span {
    font-size: 14px !important;
  }

  @media screen and (max-width: 900px) {
    display: block;
  }

  @media screen and (max-width: 600px) {
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home/meetAdvocates.vue